module.exports = __webpack_public_path__ + "static/1de3bc24.top.png";